import React, { useState, useEffect } from 'react';
import { Grid, Paper, Typography, Card, CardContent, Box } from '@mui/material';
import { Person, Business, Chat } from '@mui/icons-material';
import api from '../../services/api';

const StatCard = ({ icon, title, value, description }) => (
  <Card elevation={3} sx={{ height: '100%' }}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {icon}
        <Typography variant="h6" component="div" sx={{ ml: 1 }}>
          {title}
        </Typography>
      </Box>
      <Typography variant="h3" component="div">
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </CardContent>
  </Card>
);

const AdminOverview = () => {
  const [stats, setStats] = useState({
    userCount: 0,
    clientCount: 0,
    chatCount: 0
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // In a real implementation, these would be separate API calls to get actual statistics
        const [usersResponse, clientsResponse] = await Promise.all([
          api.get('/v1/admin/users'),
          api.get('/v1/admin/clients')
        ]);
        
        setStats({
          userCount: usersResponse.data.length || 0,
          clientCount: clientsResponse.data.length || 0,
          chatCount: 0 // Would come from a real API endpoint
        });
      } catch (error) {
        console.error('Error fetching admin statistics:', error);
      }
    };

    fetchStats();
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Admin Dashboard Overview
      </Typography>
      
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <StatCard 
            icon={<Person fontSize="large" color="primary" />}
            title="Total Users"
            value={stats.userCount}
            description="Registered users in the system"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatCard 
            icon={<Business fontSize="large" color="primary" />}
            title="Total Clients"
            value={stats.clientCount}
            description="Client organizations"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatCard 
            icon={<Chat fontSize="large" color="primary" />}
            title="Total Chats"
            value={stats.chatCount}
            description="Chat interactions"
          />
        </Grid>
      </Grid>

      <Paper elevation={2} sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          System Status
        </Typography>
        <Typography variant="body1">
          All systems operational. The StateShift platform is running normally.
        </Typography>
      </Paper>
    </Box>
  );
};

export default AdminOverview;